import {Component, HostListener, Injectable, OnInit} from '@angular/core';
import {AuthenticationService} from 'app/service/authentication.service';
import {Route, Router} from '@angular/router';
import {GaleriService} from 'app/service/galeri.service';
import {Galeri} from 'app/model/galeri.model';
import {AppComponent} from '../app.component';
import * as $ from 'jquery';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  loginScreanActivite = false;
  reference: string;
  scrHeight: any;
  scrWidth: any;
  model: any = {};
  loading = false;
  error = '';
  code: string;
  ihaleizle = false;
  browser: string = this.getBrowserName();


  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.scrHeight = window.innerHeight;
    this.scrWidth = window.innerWidth;
    if (this.scrWidth < 995) {
      document.getElementById('header-right').style.display = 'none';
      document.getElementById('header-right2').style.display = 'block';
      document.getElementById('logo').style.maxHeight = '43px';
    } else {
      document.getElementById('header-right').style.display = 'block';
      document.getElementById('header-right2').style.display = 'none';
      document.getElementById('logo').style.maxHeight = '80px';
    }
    if (this.scrWidth < 1025) {
      document.getElementById('browser').style.display = 'none';
    } else {
      document.getElementById('browser').style.display = 'block';
    }
  }

  constructor(public authenticationService: AuthenticationService,
              public galeriService: GaleriService,
              public router: Router,
              public appComponent: AppComponent,
  ) {
  }

  ngOnInit() {
    this.getScreenSize();
    this.userControl();

    $('.menu .menu-link ').click(function(){
      $('.checkbox-toggle').prop('checked', false);
    });
  }
  userControl() {
  }
  passDateControll(entity: Galeri, router, appcomp) {
    setTimeout(function () {
      let date;
      if (entity.sonSifreYenilenmeTarihi != null) {
        date = entity.sonSifreYenilenmeTarihi;
      } else {
        date = entity.uyelikTarihi;
      }
      const sonuc = new Date().getTime() - new Date(date).getTime();
      if (sonuc > (60 * 1000 * 60 * 24 * 365)) {
        appcomp.notificationOn('warn', 'Şifrenizin Kullanım Süresi Dolmuştur Lütfen Şifrenizi Değiştiriniz ...')
        router.navigate(['/bilgilerim/sifre']);
      } else {
        if (!entity.ilkSifreDegistirme) {
          appcomp.notificationOn('warn', 'Tek kulanımlık şifreyi değiştirmek zorumluluğu vardır ...')
          router.navigate(['/bilgilerim/sifre']);
        }
      }
    }, 3000);

  }

  isSignedIn() {
    //return this.authenticationService.isSignedIn();
  }

  isDisplayScreen() {
    //return this.authenticationService.isDisplayScreen();
  }

  public _extractBeginningPart(stringValue: string) {
    if (stringValue != null) {
      return stringValue.length > 10 ? stringValue.substring(0, 10) + '...' : stringValue;
    } else {
      return null;
    }
  }
  public _goToAuction() {
    this.router.navigate(['/ihaledeki-arac-detay/'], {queryParams: {izleyiciKodu: this.code}});
  }

  ihaleIzle(select) {
    if (select) {
      this.ihaleizle = true;
    } else {
      this.ihaleizle = false;
    }
  }

  public getBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase()
    switch (true) {
      case agent.indexOf('edge') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'other';
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/header/header.component.ts